import React from 'react';
import IconButtonComponent from '../IconButton/IconButton.mjs';

const BurgerButton = ({ isOpen, className, onClick }) => (React.createElement(IconButtonComponent, { className: className, iconType: isOpen ? 'close' : 'burger', "aria-label": `${isOpen ? 'Close' : 'Open'} main menu`, onClick: onClick }));

export { BurgerButton as default };
//# sourceMappingURL=BurgerButton.mjs.map
